import { useEffect, useState } from 'react';
import LegadoSelectChairs from 'src/containers/legado/LegadoSelectChairs';
import LegadoSelectDonation from 'src/containers/legado/LegadoSelectDonation';
import LegadoDonationForm from 'src/containers/legado/LegadoDonationForm';
import LegadoCheckIn from 'src/containers/legado/LegadoCheckIn';
import LegadoPersonalProgress from 'src/containers/legado/LegadoPersonalProgress';
import queryString from 'query-string';
import LegadoPostDonationTotalChurch from './LegadoPostDonationTotalChurch';
import { useHistory } from 'react-router-dom';
import membersForms from 'src/services/api/membersForms';
import { errorInput } from 'src/components/helpers';
import LegadoPromiseForm from 'src/containers/legado/LegadoPromiseForm';

const LegadoLanding = (props) => {
  const history = useHistory();
  let query = props.location.search;
  let parsedQueryString = queryString.parse(query);

  const [category, setCategory] = useState('general');
  const [modalCheckInOpen, setModalCheckInOpen] = useState('');
  const [inputs, setInputs] = useState({
    type: 'Protemplo',
    currency: 'Pesos Colombianos',
    chairs: 1,
    chairsToCommit: 0,
  });
  const [errorInputs, setErrorInputs] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (parsedQueryString.identification && !inputs.comingFromDonation) {
      setInputs({
        ...inputs,
        identification: parsedQueryString.identification,
        phone: parsedQueryString.phone || '',
        comingFromDonation: true,
      });
      setModalCheckInOpen('promiseFormValue');
    }
    if (parsedQueryString.totalChurch) {
      setCategory('totalChurch');
      history.push('/legado');
    }
    if (parsedQueryString.promiseForm) {
      setModalCheckInOpen('promiseForm');
      history.push('/legado');
    }
    if (parsedQueryString.totalPerson) {
      setModalCheckInOpen('promiseFormValue');
      history.push('/legado');
    }
  }, [parsedQueryString]);

  const verifyForm = () => {
    const mandatoryInputs = ['identification', 'phone'];
    let errorInputsCheck = {};

    mandatoryInputs.forEach((input) => {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: { name: input, value: inputs[input] },
      });
    });

    // Additional validation for identification length
    if (inputs.identification && inputs.identification.length <= 5) {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: {
          name: 'identification',
          value: inputs.identification.length >= 5,
        },
      });
    }

    // Additional validation for phone length
    if (inputs.phone && inputs.phone.length !== 10) {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: {
          name: 'phone',
          value: inputs.phone.length === 10,
        },
      });
    }

    setErrorInputs(errorInputsCheck);
    return Object.values(errorInputsCheck).includes(true);
  };

  const handleLogin = async (credentialsOverride, { skipNavigation = false } = {}) => {
    const override =
      credentialsOverride && credentialsOverride.identification ? credentialsOverride : null;
    const payload = { ...inputs, ...override };

    if (!override && verifyForm()) return;
    setLoading(true);
    try {
      const response = await membersForms.getLegadoDonations(payload);
      if (response.data.success) {
        setModalCheckInOpen('');
        const allPayments = [
          ...(response.data.payments || []),
          ...(response.data?.guest?.GuestsManualPayments || []),
        ];
        const userAllDonationsTotal = allPayments?.reduce((acc, payment) => {
          return acc + Number(payment.value || 0);
        }, 0);
        const manualPaymentsTotal = response.data?.guest?.GuestsManualPayments?.reduce(
          (acc, payment) => {
            return acc + Number(payment.value || 0);
          },
          0
        );
        const electronicPaymentsTotal = response.data.payments?.reduce((acc, payment) => {
          return acc + Number(payment.value || 0);
        }, 0);
        setInputs({
          ...payload,
          ...response.data.guest,
          allPayments,
          userAllDonationsTotal,
          manualPaymentsTotal,
          electronicPaymentsTotal,
        });
        setErrorInputs({});
        if (skipNavigation) return;
        if (response.data.guest?.id) {
          if (userAllDonationsTotal > 0 || response.data.guest?.chairsToCommit) {
            return setCategory('personalProgress');
          }
        }
        setCategory(modalCheckInOpen);
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  const reloadGuest = ({ identification, phone }) =>
    handleLogin({ identification, phone }, { skipNavigation: true });

  return (
    <>
      {category === 'general' && (
        <LegadoSelectDonation setCategory={setCategory} setModalCheckInOpen={setModalCheckInOpen} />
      )}
      {category === 'chairsToCommit' && (
        <LegadoSelectChairs
          category={category}
          inputs={inputs}
          setInputs={setInputs}
          setCategory={setCategory}
        />
      )}
      {category === 'chairs' && (
        <LegadoSelectChairs
          category={category}
          inputs={inputs}
          setInputs={setInputs}
          setCategory={setCategory}
        />
      )}
      {!!modalCheckInOpen && (
        <LegadoCheckIn
          inputs={inputs}
          setInputs={setInputs}
          setModalOpen={setModalCheckInOpen}
          setCategory={setCategory}
          errorInputs={errorInputs}
          setErrorInputs={setErrorInputs}
          handleLogin={handleLogin}
          loading={loading}
        />
      )}
      {category === 'personalProgress' && (
        <LegadoPersonalProgress
          inputs={inputs}
          backTo={'general'}
          setCategory={setCategory}
          refreshDonations={handleLogin}
          setInputs={setInputs}
        />
      )}
      {(category === 'promiseForm' || category === 'promiseFormValue') && (
        <LegadoPromiseForm
          inputs={inputs}
          setInputs={setInputs}
          setCategory={setCategory}
          category={category}
          refreshDonations={handleLogin}
          onGuestUpdated={reloadGuest}
        />
      )}
      {(category === 'donateChairs' ||
        category === 'donateSillaInParts' ||
        category === 'donateCustomAmount') && (
        <LegadoDonationForm
          category={category}
          inputs={inputs}
          setInputs={setInputs}
          setCategory={setCategory}
          onGuestUpdated={reloadGuest}
        />
      )}
      {category === 'totalChurch' && <LegadoPostDonationTotalChurch setCategory={setCategory} />}
    </>
  );
};

export default LegadoLanding;
